import { useLazyQuery, useQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import {
  Event,
  EventForCompactEventCard,
  GetEventForFanData,
  GetEventForFanVariables,
  Neighborhood,
  SharedGetDataParameters,
  VenueForFanFacingEvent,
} from 'app/shared/typings';
import { GetEventsVariables } from 'app/shared/graphql/events/queryHooks';

import {
  GET_EVENT_FOR_CHECKOUT,
  GET_EVENT_FOR_FAN,
  GET_EVENT_FOR_FEATURED_SET_PAGE,
  GET_EVENTS_FOR_FAN,
  GET_EVENTS_FOR_TODAYS_EVENTS_PAGE,
} from './queries';

interface GetEventForCheckoutVariables extends SharedGetDataParameters {
  id?: string | number;
}

interface GetEventForCheckoutData {
  event: Event;
}

export interface GetEventsForFanData {
  events: {
    __typename?: string;
    events: EventForCompactEventCard[];
    metadata: {
      totalRecords: number;
      currentPage: number;
      __typename?: string;
    };
  };
}

export const GetEventForCheckoutLazy = (
  params: GetEventForCheckoutVariables
) => {
  return useLazyQuery<GetEventForCheckoutData, GetEventForCheckoutVariables>(
    GET_EVENT_FOR_CHECKOUT,
    queryParams(params)
  );
};

export const GetEventForFan = (params: GetEventForFanVariables = {}) => {
  return useQuery<GetEventForFanData>(GET_EVENT_FOR_FAN, queryParams(params));
};

export const GetEventsForFan = (params: GetEventsVariables) => {
  return useQuery<GetEventsForFanData, GetEventsVariables>(
    GET_EVENTS_FOR_FAN,
    queryParams(params)
  );
};
export const GetEventsForFanLazy = (params: GetEventsVariables) => {
  return useLazyQuery<GetEventsForFanData, GetEventsVariables>(
    GET_EVENTS_FOR_FAN,
    queryParams(params)
  );
};

export interface GetEventsForCollectionPageData {
  events: {
    __typename?: string;
    events: EventForCompactEventCard[];
    metadata: {
      totalRecords: number;
      currentPage: number;
      __typename?: string;
    };
  };
}

export interface EventForTodaysEventsPage {
  id: string;
  isVenueConfirmed: boolean;
  venue: VenueForFanFacingEvent;
  neighborhood?: Neighborhood;
}

interface GetEventsForTodaysEventsPageData {
  events: {
    __typename?: string;
    events: EventForTodaysEventsPage[];
    metadata: {
      totalRecords: number;
      currentPage: number;
      __typename?: string;
    };
  };
}

export const GetEventsForTodaysEventsPage = (params: GetEventsVariables) => {
  return useQuery<GetEventsForTodaysEventsPageData>(
    GET_EVENTS_FOR_TODAYS_EVENTS_PAGE,
    queryParams(params)
  );
};

interface GetEventForFeaturedSetPageVariables {
  cachedSlug?: string;
}

interface GetEventForFeaturedSetPageData {
  event: {
    id: string;
    cachedSlug: string;
  };
}

export const GetEventForFeaturedSetPage = (
  params: GetEventForFeaturedSetPageVariables = {}
) => {
  return useQuery<GetEventForFeaturedSetPageData>(
    GET_EVENT_FOR_FEATURED_SET_PAGE,
    queryParams(params)
  );
};
